var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 25,
    viewBox: "0 0 60 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 25,
    rx: 8,
    fill: "#EBF1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2988 12.2207V12.6699C17.2988 13.2038 17.2321 13.6823 17.0986 14.1055C16.9652 14.5286 16.7731 14.8883 16.5225 15.1846C16.2718 15.4808 15.9707 15.707 15.6191 15.8633C15.2708 16.0195 14.8802 16.0977 14.4473 16.0977C14.0273 16.0977 13.6416 16.0195 13.29 15.8633C12.9417 15.707 12.639 15.4808 12.3818 15.1846C12.1279 14.8883 11.931 14.5286 11.791 14.1055C11.651 13.6823 11.5811 13.2038 11.5811 12.6699V12.2207C11.5811 11.6868 11.6494 11.21 11.7861 10.79C11.9261 10.3669 12.123 10.0072 12.377 9.71094C12.6309 9.41146 12.932 9.18359 13.2803 9.02734C13.6318 8.87109 14.0176 8.79297 14.4375 8.79297C14.8704 8.79297 15.2611 8.87109 15.6094 9.02734C15.9609 9.18359 16.262 9.41146 16.5127 9.71094C16.7666 10.0072 16.9603 10.3669 17.0938 10.79C17.2305 11.21 17.2988 11.6868 17.2988 12.2207ZM16.3662 12.6699V12.2109C16.3662 11.7878 16.3223 11.4134 16.2344 11.0879C16.1497 10.7624 16.0244 10.4889 15.8584 10.2676C15.6924 10.0462 15.4889 9.87858 15.248 9.76465C15.0104 9.65072 14.7402 9.59375 14.4375 9.59375C14.1445 9.59375 13.8792 9.65072 13.6416 9.76465C13.4072 9.87858 13.2054 10.0462 13.0361 10.2676C12.8701 10.4889 12.7415 10.7624 12.6504 11.0879C12.5592 11.4134 12.5137 11.7878 12.5137 12.2109V12.6699C12.5137 13.0964 12.5592 13.474 12.6504 13.8027C12.7415 14.1283 12.8717 14.4033 13.041 14.6279C13.2135 14.8493 13.417 15.0169 13.6514 15.1309C13.889 15.2448 14.1543 15.3018 14.4473 15.3018C14.7533 15.3018 15.0251 15.2448 15.2627 15.1309C15.5003 15.0169 15.7005 14.8493 15.8633 14.6279C16.0293 14.4033 16.1546 14.1283 16.2393 13.8027C16.3239 13.474 16.3662 13.0964 16.3662 12.6699ZM24.1787 8.89062V16H23.2314L19.6523 10.5166V16H18.71V8.89062H19.6523L23.2461 14.3887V8.89062H24.1787Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 2,
    width: 21,
    height: 21,
    rx: 6,
    fill: "#34629D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOn);
export default __webpack_public_path__ + "static/media/ToggleOn.6ba3e701dbaa3c715d7861e210c930fe.svg";
export { ForwardRef as ReactComponent };